import { Popover } from 'radix-ui'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import { TherapistFilterMenuTriggerUI } from '@/src/domains/therapist-filters/components/TherapistFilterMenuTrigger'

import { TherapistSessionFilterMenuContent } from './TherapistSessionFilterMenuContent'

export const TherapistSessionFilterMenuUI = () => {
  const { t } = getTranslate()

  return (
    <Popover.Popover>
      <Popover.Trigger asChild>
        <TherapistFilterMenuTriggerUI icon="video">
          {t('component.therapist.filter.event-type.trigger')}
        </TherapistFilterMenuTriggerUI>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          sideOffset={12}
          collisionPadding={12}
          avoidCollisions={false}
          align="start"
          className="dropdown-animation z-50 max-h-[var(--radix-popper-available-height)] w-[var(--radix-popover-trigger-width)] origin-[--radix-popper-transform-origin] overflow-y-auto overflow-x-hidden rounded-2xl bg-sand-500 p-0 shadow-cardShadow1 tablet:w-[380px]"
        >
          <TherapistSessionFilterMenuContent />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Popover>
  )
}
